import { Button } from '@/components/elements/forms/buttons';
import Modal from '@/components/modules/modals/redesign/Modal/Modal';
import EmptyState from '@/components/templates/EmptyState';
import { useAppDispatch } from '@/hooks';
import useMobileView from '@/hooks/useMobileView';
import { __, _s } from '@/locale';
import { getScreenName, handleLoginClick } from '@/services/navigationServices';
import { NavItemIdentifier } from '@/types/navigation';

const FavoritesLoginModal = ({ onClose, isOpen }: { onClose: () => void; isOpen: boolean }) => {
  const dispatch = useAppDispatch();
  const { isMobileView } = useMobileView();
  return (
    <Modal isOpen={isOpen}>
      <Modal.Content newDesign={true} contentPadding={false} floating={!isMobileView}>
        <Modal.Header floating={!isMobileView} newDesign={true} title="Logga in" onClose={onClose} />
        <EmptyState
          body={_s('loginForFavs')}
          title={__('loginForFavsTitle')}
          icon={<img src="/images/illustrations/favorites2.png" alt="" />}
          cta={
            <Button
              label={__('favorites.emptyState.button')}
              size="sm"
              onClick={(e) => {
                handleLoginClick(dispatch, NavItemIdentifier.LogIn, getScreenName());
                onClose();
              }}
            />
          }
        />
      </Modal.Content>
    </Modal>
  );
};

export default FavoritesLoginModal;
